import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs, CommonSelect, CstmPagination } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import NotificationTableLayout from "components/TableLayoutV2/NotificationTable";
import { dateFormat, notificationCategoryLabel, userFullName } from "helpers/common";
import userImg from "Assets/images/user.png";
import { useGetNotificationManagementUserFeedQuery, useGetNotificationsFilterTypesQuery } from "store/services/notifications";
import { useDispatch, useSelector } from "react-redux";
import { userNotificationsFilter } from "store/slices/filter";
import { EDIT_NOTES, MANAGE_NOTIFICATION_USERS, MANAGE_NOTIFICATIONS } from "config/paths";

const ManageNotificationUserFeed = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId, category } = useParams();
  const [page, setPage] = useState(1);
  const limit = 10;
  const filter = useSelector(state => state?.filter?.userNotificationsFilter);

  const { data: filterType, isFetching: filterTypesLoading } = useGetNotificationsFilterTypesQuery()
  const { data, isLoading, isFetching, isError } = useGetNotificationManagementUserFeedQuery({ userId, page, limit, ...filter });
  const notifications = data?.records || data?.notifications || data?.data || (Array.isArray(data) ? data : []);

  const total = data?.total ?? data?.totalRecords ?? data?.count ?? notifications.length;

  const handleCreateUrl = (item) => {
    const clientType = item?.module == "home_education" ? "home-education" : item?.module
    if (item?.type == 'client_assigned' || item?.type == 'client_discharged') {
      navigate(`/client/${clientType}/detail/${item?.client?.id}`)
    }
    else if (item?.type == "mdt_assigned") {
      navigate(`/manage-mdt/multidisciplinary-assessment/detail/${item?.client?.id}`)
    }
    else if (item?.type_label == "Note") {
      navigate(generatePath(EDIT_NOTES, { id: item?.metadata?.note_id }))
    }
    else {
    }
  }

  const handleFilterChange = (key) => (value) => {
    dispatch(userNotificationsFilter({ ...filter, [key]: value }))
    setPage(1); // Reset to first page when filter changes
  };

  const columns = [
    { head: "DATE", accessor: "createdAt", isComponent: true, component: (item) => <h6 className="m-0 fw-sbold">{item.createdAt ? dateFormat(item.createdAt, "MMM DD hh:mm A") : "--"}</h6> },
    { head: "BY", accessor: "actor", isComponent: true, component: (item) => <div className="d-flex align-items-center gap-2"><img src={item?.actor?.therapist_detail?.profile_picture || item?.actor?.profile_picture || userImg} alt="profile" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }} /><h6 className="m-0 fw-sbold">{userFullName(item.actor) || item?.actor?.name || "--"}</h6></div> },
    { head: "NOTIFICATION MESSAGE", accessor: "message", isComponent: true, component: (item) => <h6 className="m-0 fw-sbold">{item.message || "--"}</h6> },
    {
      head: "LINK",
      accessor: "grade",
      component: (item, ind) => <h6 onClick={() => handleCreateUrl(item)} style={{ textDecoration: "underline", cursor: "pointer", color: "#315D99" }} className="m-0 fw-sbold">{"File Link"}</h6>,
    },
    { head: "TYPE", accessor: "type_label", isComponent: true, component: (item) => <h6 className="m-0 fw-sbold">{item.type_label || item.type || "--"}</h6> },
    {
      head:
        <div className="reports-v2 gap-2 gap-lg-0 d-flex justify-content-end classroom-conslutation">
          <div className="d-flex align-items-center gap-3">
            <label className="discharge-screen-label mb-0">Type</label>
            <CommonSelect
              placeholder={"Select"}
              option={filterType?.types?.map((item) => ({ label: item, value: item }))}
              onChange={(e) => handleFilterChange("type")(e)}
              value={filter?.type}
              // onInputChange={(val) => handleSearch(val)}
              isFilterV2
              isLoading={filterTypesLoading}
              isClearable
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "100%", // ✅ Ensures the whole Select container is full width
                }),
              }}
            // isLoading={schoolsLoading}
            />
          </div>
        </div>
      ,
      accessor: "grade",
      component: (item, ind) => <h6 className="m-0 fw-sbold">{item?.type_label || "--"}</h6>,
    },
  ];
  
    const breadcrumbItems = [
      { label: "Manage Notifications", path: MANAGE_NOTIFICATIONS },
      { label: notificationCategoryLabel(category), path: generatePath(MANAGE_NOTIFICATION_USERS, { category }) },
      {label: data?.user ? userFullName(data?.user) : "Notification's Feed"}
    ];

  return <section className="client position-relative py-4">
    <Container fluid>
      {
        isLoading ? <div style={{ height: "200px" }}>
          <LoadingIndicator /></div> : 
          <Row>
            <Row style={{ paddingLeft: '12px' }} className="pt-3 mb-3">
                      <Col lg="6">
                        <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                      </Col>
                    </Row>
            <Col lg="12" className="my-2">
            <div className="d-flex align-items-center gap-2">
              <img src={data?.user?.therapist_detail?.profile_picture || userImg} alt="profile" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }} />
            <h6 className="m-0 fw-bold main-head themeBlue">
              {userFullName(data?.user)}
              </h6>
              </div>
          </Col>
          <Col lg="12" className="my-2">
            <div className="table-outer">{isError ? <ErrorComponent /> : <>{isFetching && <LoadingOverlay />}
              <NotificationTableLayout data={notifications} column={columns} />
              <CstmPagination
                totalPages={Math.ceil(total / limit)}
                className="paginationV2"
                activePage={page}
                handlePageChange={setPage} />
            </>
            }
            </div>
          </Col>
        </Row>
      }
    </Container>
  </section>;
};

export default ManageNotificationUserFeed;
